module.exports = __webpack_public_path__ + "static/media/apple-download.f638270a.svg";